import { useMutation } from '@tanstack/react-query';

import axios from 'src/lib/axios';
import { MutationConfig } from 'src/lib/react-query';
import { GeneralASError } from 'src/registry/types/axios';
import { formatResourcePath } from 'src/utils/regex';

const RESOURCE = '/subscriptions/service-plan-item/:servicePlanItemId/service-plan-item-pricing-policy/:pricingPolicyId/';

type MutationFnType = typeof mutationFn;

interface DTO {
    servicePlanItemId: string;
    pricingPolicyId: string;
}
const mutationFn = ({ servicePlanItemId, pricingPolicyId }: DTO): Promise<void> => {
    return axios.delete(formatResourcePath(RESOURCE, { servicePlanItemId, pricingPolicyId }));
};

const useMutationHook = (options: MutationConfig<MutationFnType, GeneralASError> = {}) =>
    useMutation({
        mutationFn,
        ...options,
    });

export { useMutationHook as useDeleteServicePlanPricingPolicy };
